export default {
    /* GET_RUBBERS
    ---------------------------------------------------------------
    */
    GET_RUBBERS_REQUEST: (state) => {
        state.rubbersLoading = true
    },
    GET_RUBBERS_SUCCESS: (state, data) => {
        state.rubbers = data.results
        state.rubbersLoading = false
    },

    /* GET_RUBBERS_RAW
    ---------------------------------------------------------------
    */
    GET_RUBBERS_RAW_REQUEST: (state) => {
        state.rubbersRawLoading = true
    },
    GET_RUBBERS_RAW_SUCCESS: (state, data) => {
        state.rubbersRaw = data.results
        state.rubbersRawLoading = false
    },
    GET_RUBBERS_RAW_FAILURE: (state) => {
        state.rubbersRawLoading = false
    },

    /* GENERATE_RUBBERS_REPORT
    ---------------------------------------------------------------
    */
    GENERATE_RUBBERS_REPORT: (state) => {
        state.rubbersReportLoading = true
    },
    GENERATE_RUBBERS_REPORT_SUCCESS: (state) => {
        state.rubbersReportLoading = false
    },
    GENERATE_RUBBERS_REPORT_FAILURE: (state) => {
        state.rubbersReportLoading = false
    },

    /* GET_RUBBER_STATUSES
    ---------------------------------------------------------------
    */
    GET_RUBBER_STATUSES_SUCCESS: (state, data) => {
        state.statuses = data.results
    },
    GET_RUBBER_STATUSES_FAILURE: (state) => {
        state.statuses = []
    },

    /* DELETE_RUBBER
    ---------------------------------------------------------------
    */
    DELETE_RUBBER_REQUEST: (state) => {
        state.rubbersLoading = true
    },
    DELETE_RUBBER_SUCCESS: (state) => {
        state.rubbersLoading = false
    },
    DELETE_RUBBER_FAILURE: (state) => {
        state.rubbersLoading = true
    },

    /* ADDITIONAL JOB NUMBERS SEARCH
    ---------------------------------------------------------------
    */
    SEARCH_ADDITIONAL_JOB_NUMBERS_REQUEST: (state) => {
        state.additionalJobSearchLoading = true
    },
    SEARCH_ADDITIONAL_JOB_NUMBERS_SUCCESS: (state, data) => {
        state.additionalJobSearchResults = data.results
        state.additionalJobSearchLoading = false
    },
    SEARCH_ADDITIONAL_JOB_NUMBERS_FAILURE: (state) => {
        state.additionalJobSearchResults = []
        state.additionalJobSearchLoading = false
    },
    CLEAR_ADDITIONAL_JOB_NUMBERS: (state) => {
        state.additionalJobSearchResults = []
    },

    /* SAVE ADDITIONAL JOB NUMBERS
    ---------------------------------------------------------------
    */
    SAVE_ADDITIONAL_JOB_NUMBERS_REQUEST: (state) => {
        state.additionalJobSaveLoading = true
    },
    SAVE_ADDITIONAL_JOB_NUMBERS_SUCCESS: (state) => {
        state.additionalJobSaveLoading = false
    },
    SAVE_ADDITIONAL_JOB_NUMBERS_FAILURE: (state) => {
        state.additionalJobSaveLoading = false
    },

    /* RUBBER COMMENTS
    ---------------------------------------------------------------
    */
    GET_RUBBER_COMMENTS_REQUEST: (state) => {
        state.commentsLoading = true
    },
    GET_RUBBER_COMMENTS_SUCCESS: (state, data) => {
        state.comments = data.results
        state.commentsLoading = false
    },
    GET_RUBBER_COMMENTS_FAILURE: (state) => {
        state.comments = []
        state.commentsLoading = false
    },
    CREATE_RUBBER_COMMENT_REQUEST: (state) => {
        state.commentSaveLoading = true
    },
    CREATE_RUBBER_COMMENT_SUCCESS: (state) => {
        state.commentSaveLoading = false
    },
    CREATE_RUBBER_COMMENT_FAILURE: (state) => {
        state.commentSaveLoading = false
    },
    DELETE_RUBBER_COMMENT_REQUEST: (state) => {
        state.commentDeleteLoading = true
    },
    DELETE_RUBBER_COMMENT_SUCCESS: (state) => {
        state.commentDeleteLoading = false
    },
    DELETE_RUBBER_COMMENT_FAILURE: (state) => {
        state.commentDeleteLoading = false
    },
    CLEAR_RUBBER_COMMENTS(state) {
        state.comments = []
    },
    ADD_RUBBER_COMMENT(state, comment) {
        state.comments.unshift(comment)
    },
    REMOVE_RUBBER_COMMENT(state, commentId) {
        state.comments = state.comments.filter((c) => c.id !== commentId)
    },
}
